export default __webpack_public_path__ + "static/media/careadmin_doctor_icon.7bd7fc6c.svg";